import type { FC } from 'react'
import React from 'react'
import styled from 'styled-components'

const BreadcrumbLink = styled.a`
  color: #41a7f5;
  cursor: pointer;
`

interface Props {
  label: string
  onClick?: () => void
}

const Breadcrumb: FC<Props> = ({ label, onClick }) =>
  onClick !== undefined ? (
    <BreadcrumbLink onClick={onClick}>{label}</BreadcrumbLink>
  ) : (
    <>{label}</>
  )

export default Breadcrumb
